const TIME_LINE = [
  {
    id: 'marker1',
    time: [{
      inTime: 90000,
      inPos: {x: 1575, y: 445},
      endTime: 102000,
      moveStep:0,
      endPos: {x: 2102, y: 460}
    }]
  },
  {
    id: 'marker2',
    time: [{
      inTime: 90000,
      inPos: {x: 1068, y: 470},
      endTime: 105000,
      moveStep:0,
      endPos: {x: 1757, y: 462}
    }]
  },
  {
    id: 'marker3',
    time: [{
      inTime: 112000,
      inPos: {x: 1003, y: 463},
      endTime: 124000,
      moveStep:0,
      endPos: {x: 318, y: 440}
    }]
  },
  {
    id: 'marker4',
    time: [{
      inTime: 120000,
      inPos: {x: 731, y: 475},
      endTime: 124000,
      moveStep:0,
      endPos: {x: 651, y: 472}
    }]
  },
  {
    id: 'marker5',
    time: [{
      inTime: 120000,
      inPos: {x: 878, y: 476},
      endTime: 124000,
      moveStep:0,
      endPos: {x: 846, y: 480}
    }]
  },
  {
    id: 'marker6',
    time: [{
      inTime: 120000,
      inPos: {x: 990, y: 478},
      endTime: 124000,
      moveStep:0,
      endPos: {x: 977, y: 479}
    }]
  },
  {
    id: 'marker7',
    time: [{
      inTime: 120000,
      inPos: {x: 1141, y: 474},
      endTime: 124000,
      moveStep:0,
      endPos: {x: 1153, y: 474}
    }]
  },
  {
    id: 'marker8',
    time: [{
      inTime: 178000,
      inPos: {x: 1230, y: 450},
      endTime: 200000,
      moveStep:0,
      endPos: {x: 1084, y: 464}
    }]
  },
  {
    id: 'marker9',
    time: [{
      inTime: 178000,
      inPos: {x: 1456, y: 450},
      endTime: 200000,
      moveStep:0,
      endPos: {x: 1178, y: 456}
    }]
  },
  {
    id: 'marker10',
    time: [{
      inTime: 178000,
      inPos: {x: 1648, y: 450},
      endTime: 200000,
      moveStep:0,
      endPos: {x: 1378, y: 442}
    }]
  },
  {
    id: 'marker11',
    time: [{
      inTime: 125000,
      inPos: {x: 662, y: 466},
      endTime: 177000,
      endPos: {x: 662, y: 466}
    }]
  }
];
export {TIME_LINE}



// WEBPACK FOOTER //
// ./src/webgl/timeline.js